import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash} from "react-icons/fa";
import useAuthService from "../hooks/useAuthService";


import "../styles/Register.css";
import logo from "../assets/logo512.png";

function Register() {
    const { register } = useAuthService();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        // Regular expression for strong password validation
        const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-]{8,}$/;

        if (!strongPasswordRegex.test(password)) {
            setError('Password must be at least 8 characters, include an uppercase, lowercase, number, and special character.');
            return;
        }
        try {
            await register(email, password);
            setSuccess('Registration successful! Redirecting to login...');
            setError('');

            // Redirect to login after 2 seconds
            setTimeout(() => {
                navigate('/');
            }, 2000);
        } catch (err) {
            if (err.response && err.response.status === 403) {
                setError('Email not authorized.');
            } else if (err.response && err.response.status === 400) {
                setError('Email already exists.');
            } else {
                setError(err.message);
            }
        }
    };

    return (
        <div className='register-page'>
            <div className='register-container'>
                {/* Logo */}
                <img src={logo} alt='Company Logo' className='logo' />

                {/* Register Form */}
                <form onSubmit={handleRegister}>
                    {error && <p className="error">{error}</p>}
                    {success && <p className="success">{success}</p>}
                    <div className="input-group">
                        <FaUser className="icon" />
                        <input 
                            type="email" 
                            placeholder="Email Address" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            required
                        />
                    </div>
                    <div className="input-group password-group">
                        <FaLock className="icon" />
                        <input 
                            type={showPassword ? "text" : "password"} 
                            placeholder="Password" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            required
                        />
                        <button 
                            type="button" 
                            className="toggle-password" 
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>

                    <button type="submit">Register</button>
                </form>
                {/* Footer Links */}
                <div className="footer-links">
                    <span>Already a member? <Link to="/">Sign In</Link></span>
                </div>
            </div>
        </div>
    );
}

export default Register;